(() => {
  const STORAGE_KEY = 'Concept:night-mode';
  const COOKIE_KEY = 'concept_night_mode';

  function readStored() {
    try {
      const fromStorage = window.localStorage.getItem(STORAGE_KEY);
      if (fromStorage === 'true' || fromStorage === 'false') {
        return fromStorage === 'true';
      }
    } catch (e) {}

    try {
      const match = document.cookie.match(/(?:^|; )concept_night_mode=([^;]*)/);
      if (match) return match[1] === 'true';
    } catch (e) {}

    return false;
  }

  function writeStored(enabled) {
    const value = enabled ? 'true' : 'false';
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}

    try {
      const maxAge = 60 * 60 * 24 * 365;
      document.cookie = `${COOKIE_KEY}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`;
    } catch (e) {}
  }

  function isNightMode() {
    return document.documentElement.getAttribute('data-night-mode') === 'true';
  }

  function applyNightMode(enabled) {
    if (enabled) {
      document.documentElement.setAttribute('data-night-mode', 'true');
      document.documentElement.classList.add('night-mode');
    } else {
      document.documentElement.removeAttribute('data-night-mode');
      document.documentElement.classList.remove('night-mode');
    }
  }

  function setNightMode(enabled) {
    applyNightMode(enabled);
    writeStored(enabled);
    document.dispatchEvent(
      new CustomEvent('night-mode:change', { detail: { enabled } })
    );
  }

  function isNightPage() {
    return document.documentElement.getAttribute('data-night-page') === 'true';
  }

  function restoreNightMode() {
    applyNightMode(isNightPage());
    syncToggles();
  }

  function syncToggles() {
    const enabled = isNightMode();
    document.querySelectorAll('[is="night-mode-toggle"]').forEach((button) => {
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');

      if (button.classList.contains('night-mode-fab')) {
        const iconEl = button.querySelector('.night-mode-fab__icon');
        if (iconEl) iconEl.textContent = enabled ? '☀️' : '🌙';
        button.setAttribute(
          'aria-label',
          enabled ? 'Switch to day mode' : 'Switch to night mode'
        );
        return;
      }

      const text = enabled
        ? button.dataset.labelOn || 'Day Mode ☀️'
        : button.dataset.labelOff || 'Night Mode 🌙';
      button.querySelectorAll('[data-night-mode-label]').forEach((label) => {
        label.textContent = text;
      });
    });

    updateRecommendationVisibility();
  }

  function updateRecommendationVisibility() {
    document.querySelectorAll('.shopify-section.recommendations-section').forEach((section) => {
      const cards = section.querySelectorAll('.product-card, .horizontal-product');
      const hasVisibleCard = cards.length > 0 && Array.from(cards).some((card) => {
        return getComputedStyle(card).display !== 'none';
      });

      section.classList.toggle('is-recommendations-empty', !hasVisibleCard);

      const recommendationRoot = section.querySelector('product-recommendations');
      if (recommendationRoot) {
        if (hasVisibleCard) {
          recommendationRoot.removeAttribute('hidden');
        } else {
          recommendationRoot.setAttribute('hidden', '');
        }
      }
    });
  }

  class NightModeToggle extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick);
    }

    connectedCallback() {
      // Re-assert stored preference whenever toggles mount (section reloads, etc.)
      restoreNightMode();
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      setNightMode(!readStored());
      syncToggles();
    }
  }

  if (!customElements.get('night-mode-toggle')) {
    customElements.define('night-mode-toggle', NightModeToggle, { extends: 'button' });
  }

  // Event delegation backup (section AJAX / delayed upgrades)
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[is="night-mode-toggle"]');
    if (!button) return;
    // Prefer the custom element handler when upgraded
    if (button instanceof NightModeToggle) return;
    event.preventDefault();
    event.stopPropagation();
    setNightMode(!readStored());
    syncToggles();
  });

  document.addEventListener('night-mode:change', syncToggles);
  document.addEventListener('shopify:section:load', restoreNightMode);
  document.addEventListener('collection:reloaded', restoreNightMode);
  document.addEventListener('recommendations:loaded', updateRecommendationVisibility);
  window.addEventListener('pageshow', restoreNightMode);

  restoreNightMode();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateRecommendationVisibility);
  } else {
    updateRecommendationVisibility();
  }
})();
